import { DEFAULT_LOCALE } from '@clearscore/config.i18n';

export default {
    [DEFAULT_LOCALE]: {
        title: 'Two-factor authentication',
        description: 'Please enter the 6 digit code we sent to %mobileNumber%.',
        cantGetCode: "I can't get my code",
        secureAndAuthorised: '100% Secure & Authorised',
        appDescription: 'Please enter the 6-digit code that is generated on the authenticator app.',
    },
};
